import type { Authentication } from '@barboxx/models/types';

import { createAuthContext } from '../context/AuthContext';
import { createUseAuth } from '../hooks/useAuth';
import { AuthService, createAuthProvider } from '../providers/AuthProvider';

export function createAuthentication<T extends Authentication.AuthReturn>(
    authService: AuthService<T>
) {
    const AuthContext = createAuthContext<T>(); // We type the Context based on the generic AuthService
    const useAuth = createUseAuth<T>(AuthContext);
    const AuthProvider = createAuthProvider<T>(AuthContext, authService);

    return {
        AuthContext,
        AuthProvider,
        useAuth,
    };
}
